// ENUMS #############################################################
export enum ApiTypeEnum {
	ADMIN = 'admin',
	CUSTOMER = 'customer'
}

export enum ContentAlignmentEnum {
	AS_COLUMNS = 'column',
	AS_ROWS = 'row'
}

export enum ContentDisplayTypeEnum {
	CONTENTS_AS_PAGE = 'contents as page',
	CONTENTS_AS_TAB = 'contents as tab',
	CONTENTS_ONLY = 'contents only'
}

export enum ContentTextTypeEnum {
	HTML = 'html',
	TEXT = 'text'
}

export enum ContentTypeEnum {
	DEFAULT = 'default',
	PROJECTED = 'projected'
}

export enum SalutationEnum {
	MR = 'mr',
	MRS = 'mrs',
	OTHER = 'other'
}

export enum ValueTypeEnum {
	I18N = 'i18n',
	VALUE = 'value',
}

export enum VerticalAlignmentEnum {
	BOTTOM = 'bottom',
	CENTER = 'center',
	TOP = 'top'
}


// INTERFACES ########################################################


// TYPES #############################################################
